import PropTypes from 'prop-types';
import * as FM from 'framer-motion';

export default function MotionWrapper({ children, delay = 0 }) {
  const variants = {
    initial: { opacity: 0, y: 8 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.25, ease: 'easeOut', delay }
    },
    exit: {
      opacity: 0,
      y: 8,
      transition: { duration: 0.22, ease: 'easeInOut' }
    }
  };

  return (
    <FM.AnimatePresence mode="wait">
      <FM.motion.div initial="initial" animate="animate" exit="exit" variants={variants}>
        {children}
      </FM.motion.div>
    </FM.AnimatePresence>
  );
}

MotionWrapper.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
};
